import React from 'react';
import PropTypes from 'prop-types';
import { colors } from 'kangarootime-ui';
import moment from 'moment';
import './WeekOverview.css';

const TimeOffInformation = ({ type, timeOffInfo }) => {
  const { allDay, start, end } = timeOffInfo;
  const color = type === 'approve' ? colors.success : colors.danger;
  const str = type === 'approve' ? 'Approved' : 'Denied';
  const formatTime = date => moment(date).format('h:mm A');
  const description = allDay ? 'All Day' : `${formatTime(start)} - ${formatTime(end)}`;

  return (
    <div style={{ borderBottom: '1px solid #F1F1F3' }}>
      <span className='shift-main-text' style={{ fontWeight: 600, color }}>Time Off {str}</span>
      <span className='shift-main-text' style={{ marginTop: 4, color }}>{description}</span>
    </div>
  );
};

TimeOffInformation.propTypes = {
  type: PropTypes.oneOf(['approve', 'reject']),
  timeOffInfo: PropTypes.shape({
    allDay: PropTypes.bool,
    createdAt: PropTypes.string,
    description: PropTypes.string,
    employeeId: PropTypes.number,
    end: PropTypes.string,
    id: PropTypes.number,
    start: PropTypes.string,
    status: PropTypes.shape({
      createdAt: PropTypes.string,
      createdAtById: PropTypes.number,
      status: PropTypes.string,
      statusId: PropTypes.number
    })
  })
};

export default TimeOffInformation;
